module.exports = __webpack_public_path__ + "images/bundle.77e5b3d7df77807696bdb9fd600fd622.svg";